import { useQuery } from 'react-query';
import { getCompetitionSubmissions } from 'api/services/competitions';
import { auth, useAuthState } from 'api/services/firebase';
import useIsJoined from 'hooks/useIsJoined';

const useCompetitionSubmissions = (competitionId) => {
  const [user] = useAuthState(auth);
  const isUserAvailable = !!user;

  const { isJoined, isLoading: isChecking } = useIsJoined(competitionId);
  const isSubmissionsFetchEnabled = isUserAvailable && isJoined && !isChecking;

  const {
    data = null,
    error,
    refetch,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ['competitionSubmissions', competitionId],
    queryFn: getCompetitionSubmissions(competitionId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: false,
    enabled: isSubmissionsFetchEnabled,
  });
  if (!isLoading && data !== null) {
    const competitionSubmissions = data?.submissions || {};

    return {
      competitionSubmissions,
      error,
      refetch,
      isLoading,
      isRefetching,
    };
  }

  return {
    competitionSubmissions: {},
    error,
    refetch,
    isLoading,
    isRefetching,
  };
};

export default useCompetitionSubmissions;
